import { createSlice } from "@reduxjs/toolkit";
import { clearAuthSession, setAuthSession } from "../../utils/authSession";

function getStoredUser() {
  try {
    const raw = localStorage.getItem("user");
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

const initialState = {
  isAuthenticated: sessionStorage.getItem("auth") === "1",
  user: getStoredUser(),
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setAuthenticated: (state, action) => {
      state.isAuthenticated = action.payload;
    },
    setAuthUser: (state, action) => {
      state.isAuthenticated = true;
      state.user = action.payload || null;
      if (action.payload) {
        setAuthSession(action.payload);
      }
    },
    logout: (state) => {
      state.isAuthenticated = false;
      state.user = null;
      clearAuthSession();
    },
  },
});

export const { setAuthenticated, setAuthUser, logout } = authSlice.actions;
export default authSlice.reducer;
